// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-tools {
  position: absolute;
  top: calc(100% + 3vh);
  left: 0;
  transform: translateX(0);
  transition: transform 0.3s ease-in-out;
}

.map-tools.collapseMapTools {
  transform: translateX(-100%);
}

.mapToolsBtnIcon {
  position: absolute !important;
  height: 25px !important;
  margin: 0 0 0 8px !important;
  background: white !important;
  opacity: 0.8;
  min-width: auto !important;
  display: flex !important;
  place-content: flex-start !important;
  border-radius: 16px !important;
  transform: rotate(0deg) !important;
  transition: transform 0.3s ease-in-out !important;
}

.mapToolsBtnIcon.rotate {
  transform: rotate(180deg) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Map/mapGl.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,wBAAA;EACA,sCAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,6BAAA;EACA,uBAAA;EACA,4BAAA;EACA,4BAAA;EACA,YAAA;EACA,0BAAA;EACA,wBAAA;EACA,oCAAA;EACA,8BAAA;EACA,kCAAA;EACA,iDAAA;AACF;;AACA;EACE,oCAAA;AAEF","sourcesContent":[".map-tools {\n  position: absolute;\n  top: calc(100% + 3vh);\n  left: 0;\n  transform: translateX(0);\n  transition: transform 0.3s ease-in-out;\n}\n\n.map-tools.collapseMapTools {\n  transform: translateX(-100%);\n}\n// All !Important rules are necessary to overirde Mui material\n.mapToolsBtnIcon {\n  position: absolute !important;\n  height: 25px !important;\n  margin: 0 0 0 8px !important;\n  background: white !important;\n  opacity: 0.8;\n  min-width: auto !important;\n  display: flex !important;\n  place-content: flex-start !important;\n  border-radius: 16px !important;\n  transform: rotate(0deg) !important;\n  transition: transform 0.3s ease-in-out !important;\n}\n.mapToolsBtnIcon.rotate {\n  transform: rotate(180deg) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
